import React from "react";

const DrawerContext = React.createContext({
    setOpen: (args: { content: 'filters' | 'nav', open: boolean }) => null,
    open: false
});



export default DrawerContext